// import { library, dom } from "@fortawesome/fontawesome-svg-core";

import owlCarousel from "owl.carousel";

class OwlCarouselRangeGallery {
  constructor() {
    this.initialiseOwlCarouselRangeGallery();
  }

  initialiseOwlCarouselRangeGallery() {
    // setTimeout(function () {
    $(".range-gallery .owl-carousel").each(function () {
      let $this = $(this);
      $this.owlCarousel({
        dots: true,
        responsiveClass: true,
        loop: true,
        items: 1,
        autoHeight: true,
        nav: false,
        smartSpeed: 450,
        /* 
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true, */
        responsive: {
          0: {
            nav: true,
            arrows: false,
          },
          1024: {
            nav: true,
            arrows: false,
            navText: [
              '<i class="carousel-arrow carousel-arrow--left"></i>',
              '<i class="carousel-arrow"></i>',
            ],
          },
        },
      });
    });
    // }, 300);
  }
}

export default OwlCarouselRangeGallery;



// WEBPACK FOOTER //
// ./scripts/components/OwlCarouselRangeGallery.js